import React, { useEffect, useRef, useState } from 'react';
import './PermissionHeader.scss';
import { GetRolePermissions_getPermissionRoles_headers as PermissionHeaderRow } from '../../../../types/schemaTypes';

interface PermissionHeaderProps {
    headers: PermissionHeaderRow[];
}

const PermissionHeader = ({ headers }: PermissionHeaderProps): React.ReactElement => {
    const [isSticky, setIsSticky] = useState(false);
    const overlayEl = useRef<HTMLDivElement | null>(null);
    const handleScroll = (): void => {
        if (overlayEl.current) {
            setIsSticky(overlayEl.current.getBoundingClientRect().top <= 0);
        }
    };
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', () => handleScroll);
        };
    }, []);
    return headers ? (
        <div className={`sticky-wrapper${isSticky ? ' sticky' : ''}`} ref={overlayEl}>
            <div className="PermissionHeader-HeaderContainer sticky-inner">
                <div className="PermissionHeader-TypeHeader">Permission</div>
                {headers.map((header: PermissionHeaderRow) => (
                    <div className="PermissionHeader-HeaderItem" key={header.id}>
                        {header.name}
                    </div>
                ))}
            </div>
        </div>
    ) : (
        <div />
    );
};

export default PermissionHeader;
